import React, { useContext } from "react";
import {
    EVENT_CINEMAS,
    HOYTS_CINEMAS,
    LUNA_CINEMAS,
    MOVING_STORY,
    ORANA_CINEMAS,
    PALACE_CINEMAS,
    READING_CINEMAS,
    VILLAGE_CINEMAS
} from "@config/config";
import { ApplicationContext } from "@context/ApplicationContext";
import { SearchContext } from "@context/SearchContext";
import BrandName from "@components/BrandName";
import EventLogo from "@components/CinemaGroupLogo/EventLogo";
import HoytsLogo from "@components/CinemaGroupLogo/HoytsLogo";
import LunaLogo from "@components/CinemaGroupLogo/LunaLogo";
import MovingStoryLogo from "@components/CinemaGroupLogo/MovingStoryLogo";
import OranaLogo from "@components/CinemaGroupLogo/OranaLogo";
import PalaceLogo from "@components/CinemaGroupLogo/PalaceLogo";
import ReadingsLogo from "@components/CinemaGroupLogo/ReadingsLogo";
import VillageLogo from "@components/CinemaGroupLogo/VillageLogo";
import MarkerIcon from "@components/Icons/MarkerIcon";

const VenueTitleCard = () => {
    const { venue } = useContext(SearchContext);
    const { publicSubscriberGroup } = useContext(ApplicationContext);

    const venueAddress = `${venue.address}, ${venue.city}, ${venue.state}, ${venue.postcode}`;

    let CinemaGroupLogo;

    switch (venue.cinema_group_id) {
        case HOYTS_CINEMAS:
            CinemaGroupLogo = HoytsLogo;
            break;
        case VILLAGE_CINEMAS:
            CinemaGroupLogo = VillageLogo;
            break;
        case EVENT_CINEMAS:
            CinemaGroupLogo = EventLogo;
            break;
        case LUNA_CINEMAS:
            CinemaGroupLogo = LunaLogo;
            break;
        case PALACE_CINEMAS:
            CinemaGroupLogo = PalaceLogo;
            break;
        case READING_CINEMAS:
            CinemaGroupLogo = ReadingsLogo;
            break;
        case ORANA_CINEMAS:
            CinemaGroupLogo = OranaLogo;
            break;
        case MOVING_STORY:
            CinemaGroupLogo = MovingStoryLogo;
            break;
        default:
            CinemaGroupLogo = () => null;
            break;
    }

    return (
        <>
            {publicSubscriberGroup !== 0 ? (
                <div className="search-details-venue">
                    <div className="search-details-venue__wrapper">
                        <div className="search-details-venue__wrapper-inner">
                            <picture className="search-details-venue__picture">
                                <source media="(min-width: 768px)" srcSet={venue.large_image_url} />
                                <img
                                    className="search-details-venue__image"
                                    src={venue.large_image_url}
                                    alt={venue.name} />
                            </picture>
                            <div className="search-details-venue__text-container">
                                <div className="search-details-venue__logo">
                                    <CinemaGroupLogo />
                                </div>
                                <div className="search-details-venue__text-content">
                                    <h1 className="search-details-venue__title">{venue.name}</h1>
                                    <p className="search-details-venue__text">In partnership with <BrandName />, the home of independent cinema in Australia.</p>
                                    <p className="search-details-venue__text">Your one-stop-shop for great value tickets at Indie cinemas Australia-wide.</p>
                                </div>
                            </div>
                        </div>
                        <div className="search-details-venue__address-container">
                            <p className="search-details-venue__address-text">{venueAddress}</p>
                            <div className="search-details-venue__address">
                                <MarkerIcon className="search-details-venue__icon" />
                                <a
                                    className="search-details-venue__directions"
                                    target="_blank"
                                    rel="noreferrer"
                                    href={encodeURI(
                                        `https://www.google.com/maps/place/${venueAddress}`,
                                    )}
                                >Get directions
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            ): (
                <div className="search-details-venue">
                    <div className="search-details-venue__text-container">
                        <h1 className="search-details-venue__title">{venue.name}</h1>
                        <h2 className="search-details-venue__text">{venueAddress}</h2>
                        <div className="search-details-venue__group">
                            <MarkerIcon className="search-details-venue__icon" />
                            <a
                                className="search-details-venue__directions"
                                target="_blank"
                                rel="noreferrer"
                                href={encodeURI(
                                    `https://www.google.com/maps/place/${venueAddress}`,
                                )}
                            >Get directions
                            </a>
                        </div>
                    </div>
                    <div className="search-details-venue__wrapper">
                        <picture className="search-details-venue__picture">
                            <source media="(min-width: 768px)" srcSet={venue.large_image_url} />
                            <img
                                className="search-details-venue__image"
                                src={venue.large_image_url}
                                alt={venue.name} />
                        </picture>
                    </div>
                    <span className="search-details-venue__background"></span>
                </div>
            )}
        </>

    );
};

export default VenueTitleCard;
